<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Confirmación de Datos</title>
</head>
<body>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="container-custom">
          <h4 class="text-center">Confirma tus datos</h4>
          <div class="card-details">
            <p><strong>Teléfono:</strong> {{ this.phoneNumber }}</p>
            <!-- <p><strong>Correo:</strong> </p> -->
            <p>
              <strong>Número de tarjeta:</strong>
              {{ _paymentService.bindcardgen }}
            </p>
            <p>
              <strong>Vencimiento:</strong>
              {{ _paymentService.expiratesdatecard }}
            </p>
          </div>
          <!-- <button class="btn btn-continue btn-block" (click)="pinpageupdate()">
            Continuar
          </button> -->
          <button class="btn btn-continue btn-block">
            Continuar
          </button>
          <a (click)="goBack()" class="btn-back">Cambiar datos de tarjeta</a>
        </div>
      </div>
    </div>
  </div>
</body>
